import { render, staticRenderFns } from "./modalDetalleCalificaciones.vue?vue&type=template&id=666ea416&scoped=true&"
import script from "./modalDetalleCalificaciones.vue?vue&type=script&lang=js&"
export * from "./modalDetalleCalificaciones.vue?vue&type=script&lang=js&"
import style0 from "./modalDetalleCalificaciones.vue?vue&type=style&index=0&id=666ea416&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666ea416",
  null
  
)

export default component.exports